import { PASSWORD_RULE_MESSAGE } from '@gozoki/api-types/src/validation/messages'
import { PASSWORD_REGEX } from '@gozoki/tools'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

export const zUserAdminForm = z.object({
  adminRights: z.number(),

  email: z.email({ message: 'Email invalide.' }).max(50, { message: 'Email trop long.' }),

  firstName: z
    .string()
    .min(2, { message: 'Le prénom doit contenir au moins 2 caractères' })
    .max(30, { message: 'Le prénom doit contenir au maximum 30 caractères' }),

  lastName: z
    .string()
    .min(1, { message: 'Le nom de famille doit contenir au moins 1 caractère' })
    .max(30, { message: 'Le nom de famille doit contenir au maximum 30 caractères' }),

  password: z.string().regex(PASSWORD_REGEX, { message: PASSWORD_RULE_MESSAGE }).nullable(),

  storeId: z.number().nullable(),
})

export type UserAdminForm = z.infer<typeof zUserAdminForm>

// Form hook
export const useUserAdminForm = () => {
  const form = useForm<UserAdminForm>({
    // Validation function
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      password: null,
      adminRights: 0,
      storeId: null,
    },
    resolver: zodResolver(zUserAdminForm),
  })

  return form
}
